import React from 'react';
import './kovin.css';

const DipakKumarSah = () => {
  return (
    <div className="kovin-container">
      {/* Animated Header with Gradient */}
      <header className="kovin-header">
        {/* <div className="logo-container">
          <img src="/round-eyecare.webp" alt="Eye Care Institute Logo" className="logo logo-left" />
          <div className="logo-spacer"></div>
          <img src="/round-association.png" alt="Optometry Org Logo" className="logo logo-right" />
        </div> */}

        <div className="title-group">
          <div className="conference-meta">
            <h2 className="conference-location">1<sup>st</sup> International Optometric Conference</h2>
            <h2 className="conference-location">in Sri Lanka</h2>
            <h2 className="conference-year">Vision Beyond Borders – Advancing Global Eye Care</h2>
          </div>
          

        </div>
      </header>

      {/* Main Content Area */}
      <div className="content-section">
        {/* Decorative Elements */}
        <div className="decorative-elements">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <img src="/lotus.png" alt="Lotus Tower" className="lotus-img" />
        </div>

        {/* Speaker Profile */}
        <div className="speaker-info">
          <div className="speaker-label-container">
            <h2 className="speaker-label">
              <span className="label-top">International</span>
              <span className="label-bottom">Speaker</span>
            </h2>
            <div className="label-decoration"></div>
          </div>

          <div className="profile-area">
            <div className="round-photo-container">
              <div className="round-photo">
                <img src="/dipak.png" alt="Dipak Kumar Sah" />
              </div>
              <div className="photo-ring"></div>
              <div className="photo-dots">
                {[...Array(12)].map((_, i) => <div key={i} className="dot"></div>)}
              </div>
            </div>
            
            <div className="name-bar">
              <h3>Dipak Kumar Sah</h3>
              <div className="name-underline"></div>
            </div>
          </div>




<div className="bio-container">
  <p className="bio">

    <strong>Affiliation(s):</strong><br/>
    • UK Health Security Agency, London<br/>
    • London School of Hygiene & Tropical Medicine (LSHTM) and London School of Economics and Political Science (LSE)<br/>
    • Chevening Scholar<br/>
    • Eye Health Hero (2020), International Agency for the Prevention of Blindness (IAPB)<br/>
    • Former National Consultant – World Health Organization (WHO), Nepal<br/>
    • Former Technical Advisor, FHI 360<br/>
    • President: Health and Education for Poverty Alleviation (HEPA)<br/><br/>


    <strong>Profile Summary:</strong><br/>
    Dipak Kumar Sah is a dedicated health policy and systems specialist with over a decade of experience 
    working across eye health, health systems strengthening, and public health advocacy in Nepal. He is 
    further enhancing his capacity to influence evidence-based and equity-driven health policy.<br/><br/>

    He has played a pivotal role in advocating for the integration of eye care into Nepal’s public health system, 
    working closely with the Ministry of Health and Population, WHO, IAPB, and other partners. His efforts have 
    contributed to national policy development, strategic planning, and financing discussions that prioritize 
    inclusive and accessible eye care for all, particularly underserved populations.<br/><br/>

    Dipak’s work blends grassroots understanding with global policy insight, focusing on sustainable financing, 
    workforce development, and service delivery innovations that strengthen health systems and advance 
    universal health coverage (UHC).<br/><br/>


    <strong>Areas of Expertise:</strong><br/>
    • Eye Health Policy and Advocacy<br/>
    • Health Systems Strengthening<br/>
    • Public Health Education and Communication<br/>
    • Health Financing and UHC Integration<br/>
    • Monitoring, Evaluation, and Learning<br/>
    • Community Engagement and Health Equity<br/>

  </p>

  <div className="bio-decoration"></div>
</div>





        </div>
      </div>

      {/* Footer with Conference Details */}
      <footer className="conference-footer">
        <div className="footer-details">
        <p className="date-venue">Registration Until 24<sup>th</sup> of January, 2026</p>
          <p className="register-cta">Register Now <span>&rarr;</span><a href="https://eyecare2026.com/payment">Click Here</a></p>
        </div>
      </footer>
    </div>
  );
};

export default DipakKumarSah;